export default {
  findCurrentNode(flowInstanceNodes) {
    if (!flowInstanceNodes || !flowInstanceNodes) {
      return null;
    }
    return flowInstanceNodes.find(item => item.nodeStatus === "2");
  }

};
